import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {environment} from '../environments/environment';
import { AppComponent } from './app.component';
import { AppResolver } from './app.resolver';
import {AuthGuard, NoPermissionComponent, PermissionsGuard} from '@zonar-ui/auth';
import {IsZonarUserGuard} from '@app/shared/is-zonar-user-guard.service';


const routes: Routes = [
    {
        path: '',
        component: AppComponent,
        canActivate: [AuthGuard],
        resolve: {
			data: AppResolver
		},
        children: [
        {
            path: '',
            loadChildren: () => import('./modules/udl/udl-list/udl-list.module').then(m => m.UDLListModule),
            canActivate: [],
        },
        {
            path: 'udls/bulk',
            loadChildren: () => import('./modules/udl/udl-bulk-assign/udl-bulk-assign.module').then(m => m.UdlBulkAssignModule),
            canActivate: [],
        },
        {
            path: 'udls/:id',
            loadChildren: () => import('./modules/udl/udl-detail/udl-detail.module').then(m => m.UDLDetailModule),
            canActivate: [],
        },
        // Enable this route once the permissions are enforced
        {
            path: 'no-driver-reasons',
            loadChildren: () => import('./modules/no-driver-reason/no-driver-reason.module').then(m => m.NoDriverReasonModule),
            canActivate: [AuthGuard, PermissionsGuard] //todo re-add PermissionsGuard when bugs are fixed
        },
        {
            path: 'driver-logs',
            loadChildren: () => import('./modules/driver-logs/driver-logs.module').then(m => m.DriverLogsModule),
            canActivate: [AuthGuard, PermissionsGuard],
        },
        {
            path: 'hours',
            loadChildren: () => import('./modules/driver-hours-report/driver-hours-report.module').then(m => m.DriverHoursReportModule),
            canActivate: [AuthGuard]
        },
        {
            path: 'violations',
            loadChildren: () => import('./modules/violations-report/violations-report.module').then(m => m.ViolationsReportModule),
            canActivate: [AuthGuard]
        },
        {
            path: 'malfunctions',
            loadChildren: () => import('./modules/malfunctions-report/malfunctions-report.module').then(m => m.MalfunctionsReportModule),
            canActivate: [AuthGuard]
        },
        {
            path: 'availability',
            loadChildren: () => import('./modules/availability-report/availability-report.module').then(m => m.AvailabilityReportModule),
            canActivate: [AuthGuard]
        },
        {
            path: 'sds',
            loadChildren: () => import('./modules/sds-report/sds-report.module').then(m => m.SdsReportModule),
            canActivate: [AuthGuard]
        },
        {
            path: 'overview',
            loadChildren: () => import('./modules/overview/overview.module').then(m => m.OverviewModule),
            canActivate: [AuthGuard]
        }
        ]
    },
    {
        path: 'no-permission-route',
        component: NoPermissionComponent ,
    },
    {
        path: '**',
        loadChildren: () => import('./modules/zui-page-not-found/zui-page-not-found.module').then(m => m.ZuiPageNotFoundModule),
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {relativeLinkResolution: 'legacy'})],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
